import "raf/polyfill";
// import 'core-js/es5/map';
// import 'core-js/es5/set';
import "core-js/es6/map";
import "core-js/es6/set";
import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React, { Component } from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import "babel-polyfill";
import Loader from "./components/Common/Loader";
import { indexRoutes, mainRoutes } from "./routes/index";
import adminStore from "./store";

import AuthGuardImp from "./components/Common/AuthGuard";
import RestrictedImp from "./components/Common/Restricted";
import "../src/assets/scss/material-dashboard-pro-react.css?v=1.3.0";
// import "../../node_modules/toastr/build/toastr.min.css";
import 'toastr/build/toastr.min.css';
import toastr from "toastr";
toastr.options = {
  closeButton: true,
  progressBar: true,
  preventDuplicates: true,
};
export const hist = createBrowserHistory();

export class Routes extends Component {
  render() {
    return (
      <Router history={hist}>
        <div>
          <Loader />
          <Switch>
            <Route path="/restrict" component={RestrictedImp} />
            {mainRoutes.map((prop, key) => {
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
            {indexRoutes.map((prop, key) => {
              return (
                <AuthGuardImp
                  path={prop.path}
                  component={prop.component}
                  key={key}
                />
              );
            })}
          </Switch>
        </div>
      </Router>
    );
  }
}

const Main = () => (
  <Provider store={adminStore}>
    <Routes />
  </Provider>
);

render(<Main />, document.getElementById("root"));
